export const BridgeIcon = ({className}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 640 512"
    >
      <path d="M120 8H105.2L98.5 21.3c-21.1 42.2-56.8 71.4-96 97.9l26.9 39.8C51.7 143.9 75 126.7 96 105.4V256H16 0v16 64 16H16 96V496v16h16 64 16V496 352H448V496v16h16 64 16V496 352h80 16V336 272 256H624 544V105.4c21 21.3 44.3 38.5 66.6 53.6l26.9-39.8c-39.2-26.5-74.9-55.7-96-97.9L534.8 8H520 504 490.1l-6.9 12.1C447.6 82.4 389.4 120 320 120s-127.6-37.6-163.2-99.9L149.9 8H136 120zm360 94.4V256H440V133.9c14.4-9 27.7-19.6 40-31.6zM200 256H160V102.4c12.3 12 25.6 22.6 40 31.6V256zm96 0H248V156.5c15.3 5.1 31.3 8.5 48 10.3V256zm96 0H344V166.8c16.7-1.7 32.7-5.2 48-10.2V256z"/>
    </svg>
  )
}